import API from './api'

export async function getPhotographerByLogin(login) {
  let response
  try {
    response = await API.get(`photographer-public/?login=${login}`)
    response = response.data[0]
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getPhotographerByDomain(domain) {
  let response
  try {
    response = await API.get(`photographer-public/?domain=${domain}`)
    response = response.data[0]
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getPhotographer(UID, token) {
  let response
  try {
    response = await API.get(`photographer/${UID}/`, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function updatePhotographer(UID, token, body) {
  let response
  try {
    response = await API.patch(`photographer/${UID}/`, body, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function patchPhotographerPhoto(formData, identifier, token) {
  let response
  try {
    response = await API.patch(`/photographer/${identifier}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `token ${token}`,
      },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function postCoverImage(form, identifier, token) {
  let response
  try {
    response = await API.post(`/photographer/${identifier}/cover-image/`, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `token ${token}`,
      },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function sendPhotographerEmail(formData, identifier) {
  let response
  try {
    response = await API.post(`/photographer-public/${identifier}/message/`, formData)
  } catch (error) {
    response = error.response
  }
  return response
}

export async function sendMarketplacePhotographerEmail(formData, identifier) {
  let response
  try {
    response = await API.post(`/photographer-public/${identifier}/marketplace-message/`, formData)
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getPublicPhotographer(UID) {
  let response
  try {
    response = await API.get(`photographer-public/${UID}/`)
  } catch (error) {
    response = error.response
  }
  return response
}
